import { render, staticRenderFns } from "./PregledKretanjaVozaca.vue?vue&type=template&id=075f226c&scoped=true&"
import script from "./PregledKretanjaVozaca.vue?vue&type=script&lang=ts&"
export * from "./PregledKretanjaVozaca.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "075f226c",
  null
  
)

export default component.exports